import { Glyphs, WidgetMicroButton } from '../../../../rapid-ui'
import { useLayerTreeActions } from '../../use-layer-tree-actions'

export function DuplicateLayerButton({ layerId }: { layerId: string }) {
	const { duplicateLayer } = useLayerTreeActions()

	return (
		<WidgetMicroButton variant="naked" title="Duplicate layer" onClick={() => duplicateLayer(layerId)}>
			<Glyphs.core.CopyIcon />
		</WidgetMicroButton>
	)
}
